<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 18 18"
    :aria-labelledby="iconName"
    :style="`marginTop: ${offsetCorrectionY}; marginLeft: ${offsetCorrectionX}; fill: ${iconColor}`"
    role="presentation"
  >
    <title :id="iconName" lang="en">{{iconName}}</title>
    <g :fill="iconColor">
      <slot />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box'
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    },
    offsetCorrectionY: {
      type: String,
      default: '0px'
    },
    offsetCorrectionX: {
      type: String,
      default: '0px'
    }
  }
}
</script>
